export default __webpack_public_path__ + "media/zurb/img/case-study-paysa/paysa-hero-screenshot-26f744d2cec019af95f13ec3349da0a4.png";